import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { ConversationTurn } from '../api';
import { messages } from '../messages';
import { useStyles } from './styles';

type RichStep = Extract<
  ConversationTurn['reply'][number],
  { type: 'rich' }
>['step'];

const labels = {
  openings: messages.richStepOpenings,
  openings_nearby: messages.richStepOpeningsNearby,
  application_form: messages.richStepApplicationForm,
  question: messages.richStepQuestion,
  application_submitted: messages.richStepApplicationSubmitted,
  other: messages.transcriptStepPlaceholder,
};

export const RichStepCompact = ({ step }: { step: RichStep }) => {
  const classes = useStyles();
  const intl = useIntl();
  const text = step.kind === 'question' ? step.question : step.message;

  return (
    <div className={classes.richStep}>
      <Typography component="div" className={classes.richStepKind}>
        {intl.formatMessage(labels[step.kind], {
          stepName: step.tool_name ?? '',
        })}
      </Typography>
      {step.kind === 'openings'
        ? step.openings?.map(opening => (
            <div key={opening.id} className={classes.richOpening}>
              <Typography
                component="div"
                variant="h4"
                className={classes.primary}
              >
                {opening.title ?? intl.formatMessage(messages.unknownOpening)}
              </Typography>
              {opening.location != null && (
                <Typography
                  component="div"
                  variant="body2"
                  className={classes.secondary}
                >
                  {opening.location}
                </Typography>
              )}
            </div>
          ))
        : step.kind !== 'other' &&
          text && (
            <Typography
              className={classNames(classes.paragraph, classes.richStepText)}
            >
              {text}
            </Typography>
          )}
    </div>
  );
};
